const STORAGE_KEY = "rile.requestBranchIds";

function normalizeIds(ids) {
  if (!Array.isArray(ids)) return [];
  return ids
    .map((id) => (id == null ? "" : String(id).trim()))
    .filter((id) => id.length > 0);
}

function readStoredBranchIds() {
  try {
    if (typeof window === "undefined") return [];
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return normalizeIds(parsed);
  } catch {
    return [];
  }
}

function writeStoredBranchIds(ids) {
  try {
    if (typeof window === "undefined") return;
    if (!ids || ids.length === 0) {
      window.localStorage.removeItem(STORAGE_KEY);
      return;
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // Ignore storage errors (private mode / quotas)
  }
}

let branchIds = readStoredBranchIds();

export function setRequestBranchIds(ids) {
  branchIds = normalizeIds(ids);
  writeStoredBranchIds(branchIds);
}

export function getRequestBranchIds() {
  return branchIds;
}

export function getStoredBranchIds() {
  return readStoredBranchIds();
}

export function clearRequestBranchIds() {
  branchIds = [];
  writeStoredBranchIds([]);
}
